"use strict";

exports.__esModule = true;
exports.makeDatasetMetadataPropEntry = void 0;
var _dataset = require("../../entities/dataset");
const makeDatasetMetadataPropEntry = ({
  dataset,
  propName,
  propConnection: {
    datasetMetadataKey
  }
}) => datasetMetadataKey === 'totalCount' && dataset.pagination.type !== 'cursor' ? [propName, String(_dataset.Dataset.getTotalCount(dataset))] : undefined;
exports.makeDatasetMetadataPropEntry = makeDatasetMetadataPropEntry;
//# sourceMappingURL=make-dataset-metadata-prop-entry.js.map